import { Form } from "react-bootstrap";

const CustomDropDown = ({ options, handleChange, label, champs, value }) => {
  //console.log(value);
  //console.log(options);
  return (
    <div className="text-start pt-2 pb-2 w-100">
      <label className="f16 ">{label} </label>
      <Form.Select
        className="styleInput"
        onChange={(e) => handleChange(e.target.value, champs)}
        defaultValue={value}
      >
        {options.map((el, index) => (
          <option key={index} value={el.value}>
            {el.text}
          </option>
        ))}
      </Form.Select>
    </div>
  );
};

export default CustomDropDown;
